import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useConversionStore } from "../../store/conversionStore";

export const OptionsPanel: React.FC = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const { options, setOptions } = useConversionStore();

  return (
    <div className="options-panel">
      <button
        className="options-panel__toggle"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
      >
        <span>⚙ {t("options.title")}</span>
        <span className="options-panel__chevron">{open ? "▲" : "▼"}</span>
      </button>

      {open && (
        <div className="options-panel__body">
          <label className="option-row">
            <input
              type="checkbox"
              checked={options.include_images}
              onChange={(e) => setOptions({ include_images: e.target.checked })}
            />
            <div>
              <span className="option-row__label">{t("options.includeImages")}</span>
              <span className="option-row__hint">{t("options.includeImagesHint")}</span>
            </div>
          </label>

          <label className="option-row">
            <input
              type="checkbox"
              checked={options.ocr_enabled}
              onChange={(e) => setOptions({ ocr_enabled: e.target.checked })}
            />
            <div>
              <span className="option-row__label">{t("options.ocrEnabled")}</span>
              <span className="option-row__hint">{t("options.ocrEnabledHint")}</span>
            </div>
          </label>

          <label className="option-row">
            <input
              type="checkbox"
              checked={options.preserve_tables}
              onChange={(e) => setOptions({ preserve_tables: e.target.checked })}
            />
            <div>
              <span className="option-row__label">{t("options.preserveTables")}</span>
              <span className="option-row__hint">{t("options.preserveTablesHint")}</span>
            </div>
          </label>

          <label className="option-row">
            <input
              type="checkbox"
              checked={options.heading_heuristic}
              onChange={(e) => setOptions({ heading_heuristic: e.target.checked })}
            />
            <div>
              <span className="option-row__label">{t("options.headingHeuristic")}</span>
              <span className="option-row__hint">{t("options.headingHeuristicHint")}</span>
            </div>
          </label>
        </div>
      )}
    </div>
  );
};
